var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pageInfo)?_c('span',[_vm._v(_vm._s(_vm.result))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }